import EyeClosed from "@assets/images/EyeClosed.svg";
import Eye_1 from "@assets/images/Eye_1.svg";
import Eye_2 from "@assets/images/Eye_2.svg";
import Lock from "@assets/images/Lock.svg";
import LockKey from "@assets/images/LockKey.svg";
import LockOpen from "@assets/images/LockOpen.svg";
import Pencil from "@assets/images/Pencil.svg";
import Primary from "@assets/images/Primary.svg";
import copy from "@assets/images/copy.svg";
import createwheel from "@assets/images/createwheel.svg";
import crossIcon from "@assets/images/cross-icon.svg";
import cross from "@assets/images/cross.svg";
import delete_icon from "@assets/images/delete_icon.svg";
import edit from "@assets/images/edit.svg";
import email from "@assets/images/email.svg";
import emptyWheel2 from "@assets/images/empty-wheel.svg";
import facebook_logo from "@assets/images/facebook_logo.svg";
import favourite from "@assets/images/favourite.svg";
import fb from "@assets/images/fb.svg";
import filter_icon from "@assets/images/filtersundericon.svg";
import google from "@assets/images/google.svg";
import apple from "@assets/images/apple.svg";
import google2 from "@assets/images/google2.svg";
import google_logo from "@assets/images/google_logo.svg";
import image from "@assets/images/image-upload.svg";
import info2 from "@assets/images/info2.svg";
import link from "@assets/images/link.svg";
import linkpopup from "@assets/images/linkpopup.svg";
import messenger from "@assets/images/messenger.svg";
import search_icon from "@assets/images/opensearch.svg";
import SegmentPreview from "assets/images/segment-preview.svg";
import pinterest from "@assets/images/pinterest.svg";
import referralsIcon from "@assets/images/referrals.svg";
import Referrals from "@assets/images/referrals2.svg";
import refresh from "@assets/images/refresh.svg";
import revenueIcon from "@assets/images/revenue.svg";
import search from "@assets/images/search.svg";
import share from "@assets/images/share.svg";
import signup_logo from "@assets/images/signup_logo.svg";
import twitter from "@assets/images/twitterIcon.svg";
import unlink from "@assets/images/unlink.svg";
import unlockIcon from "@assets/images/unlock.svg";
import upload from "@assets/images/upload.svg";
import validation_error from "@assets/images/validation_error.svg";
import vertical_dots from "@assets/images/vertical_dots.svg";
import video from "@assets/images/video.svg";
import website from "@assets/images/web.svg";
import wheelPrivate from "@assets/images/wheel-not-found.svg";
import wheelSetting from "@assets/images/wheel-settings.svg";
import wheel_img from "@assets/images/wheel_img.svg";
import beta from "assets/images/beta.svg";
import authenticator from "assets/images/settings/authenticator.svg";
import signup_rightimg from "../assets/images/iyuga-login.png";
import SearchIcon2 from "@assets/images/SearchIcon.svg";
import SearchIconActive from "@assets/images/SearchIconActive.svg";
import ClearIcon from "@assets/images/clear.svg";

import AddSocialMedia from "@assets/images/AddSocialMedia.svg";
import arrowArcLeft from "@assets/images/ArrowArcLeft.svg";
import Check from "@assets/images/Check.svg";
import CheckCircle from "@assets/images/CheckCircle.svg";
import LinkBreak from "@assets/images/LinkBreak.svg";
import NonPrimary from "@assets/images/NonPrimary.svg";
import plus from "@assets/images/Plus.png";
import profileFacebook from "@assets/images/Profile_Facebook.svg";
import {
  default as bb_social_twitter,
  default as profileTwitter,
} from "@assets/images/Profile_Twitter.svg";
import ReferInitialBg from "@assets/images/ReferInitialBg.svg";
import StaticTimedWheel from "@assets/images/StaticTimedWheel.svg";
import aiGeneratorIcon from "@assets/images/aiGeneratorIcon.svg";
import analyticsBg from "@assets/images/analyticsBg.svg";
import AttachIcon from "@assets/images/attach.svg";
import attachment from "@assets/images/attachment.svg";
import backgroundWheelProfile from "@assets/images/backgroundWheelProfile.svg";
import backroundWheel from "@assets/images/backroundWheel.svg";
import bb_default_profile_image from "@assets/images/bb_default_profile_image.svg";
import bb_social_instagram from "@assets/images/bb_social_instagram.svg";
import bb_social_linkedin from "@assets/images/bb_social_linkedin.svg";
import bb_social_tiktok from "@assets/images/bb_social_tiktok.svg";
import bb_upload_adv_img from "@assets/images/bb_upload_adv_img.svg";
import canvasIcon from "@assets/images/canvasIcon.svg";
import clock from "@assets/images/clock.svg";
import clone from "@assets/images/clone.png";
import Clone from "@assets/images/clone.svg";
import Completed from "@assets/images/completed.svg";
import createWheelEyeIcon from "@assets/images/createWheel/Eye.svg";
import createWheelLockIcon from "@assets/images/createWheel/Lock.svg";
import createWheelPrimaryIcon from "@assets/images/createWheel/Primary.svg";
import custom_default from "@assets/images/createWheel/custom_default.svg";
import time_default from "@assets/images/createWheel/time_default.svg";
import uploadImage from "@assets/images/createWheel/upload.svg";
import customock_img from "@assets/images/customock_img.svg";
import expandWhite from "@assets/images/expand-white.svg";
import expand from "@assets/images/expand.svg";
import gradientBg from "@assets/images/gradientBg.png";
import gradientBgNew from "@assets/images/gradientBgNew.png";
import instagram from "@assets/images/instagramIcon.svg";
import legendIcon from "@assets/images/legendIcon.svg";
import linksIcon from "@assets/images/linksIcon.svg";
import mediaSidebarIcon from "@assets/images/mediaSidebarIcon.svg";
import nextMonthsIncome from "@assets/images/nextMonthsIncome.svg";
import padlock from "@assets/images/padlock.png";
import peye from "@assets/images/peye.svg";
import peye_off from "@assets/images/peye_off.svg";
import ReferQr from "@assets/images/referQr.svg";
import EyeDropper from "assets/images/eyedropper.svg";
import removeIcon from "@assets/images/removeIcon.svg";
import search_Icon from "@assets/images/search_Icon.svg";
import settings from "@assets/images/settings.svg";
import explore from "@assets/images/explore.svg";
import tabClone from "@assets/images/tabClone.svg";
import tabGallery from "@assets/images/tabGallery.svg";
import tabPrivate from "@assets/images/tabPrivate.svg";
import tabUnlock from "@assets/images/tabUnlock.svg";
import timemock_img from "@assets/images/timemock_img.svg";
import totalIncome from "@assets/images/totalIncome.svg";
import viewMediaIcon from "@assets/images/viewMediaIcon.svg";
import ytdIncome from "@assets/images/ytdincome.svg";
import Office from "assets/images/office.svg";

import Bing from "@assets/images/Bing.svg";
import Hamburger from "@assets/images/Hamburger.svg";
import MediaWhite from "@assets/images/MediaWhite.svg";
import Pexels from "@assets/images/Pexels.svg";
import resetIcon from "@assets/images/ResetIcon.svg";
import TooltipFill from "@assets/images/Tooltip-fill.svg";
import TooltipOutlilne from "@assets/images/Tooltip-outlilne.svg";
import UNDER_CONSTRUCTION from "@assets/images/UNDER_CONSTRUCTION.png";
import PinnedIcon from "@assets/images/Vectorpinned.svg";
import UnPinnedIcon from "@assets/images/Vectorunpinned.svg";
import addLink from "@assets/images/addLink.svg";
import addSegmentIcon from "@assets/images/addSegmentIcon.svg";
import aiBot from "@assets/images/aiBot.svg";
import aiError from "@assets/images/aiError.svg";
import author from "@assets/images/author.svg";
import businessbox from "@assets/images/bbox.svg";
import bg from "@assets/images/bg.png";
import blueClone from "@assets/images/blueClone.svg";
import blueHeart from "@assets/images/blueHeart.svg";
import blueShare from "@assets/images/blueShare.svg";
import BotIcon from "@assets/images/botIcon.svg";
import cloneDark from "@assets/images/cloneDark.svg";
import copyIcon from "@assets/images/copyIcon.svg";
import createWheelNav from "@assets/images/createWheelNav.svg";
import customizeIcon from "@assets/images/customizeIcon.svg";
import deleteIcon2 from "@assets/images/deleteIcon.svg";
import discovericon from "@assets/images/discovericon.svg";
import doc from "@assets/images/doc.svg";
import download from "@assets/images/download.svg";
import emoji from "@assets/images/emoji.svg";
import emptyWheel from "@assets/images/emptyWheel.svg";
import eye from "@assets/images/eye.svg";
import feedback2 from "@assets/images/feedback.svg";
import feedbackIcon from "@assets/images/feedbackIcon.svg";
import Content_Full_Preview from "@assets/images/fullPreview.svg";
import Wheely from "assets/images/wheely.svg";
import halloffame from "@assets/images/halloffame.svg";
import hotbarIcon from "@assets/images/hotbarIcon.svg";
import Business from "@assets/images/segmentEditor/Busniess.svg";
import Hotbar from "@assets/images/Hotbar.svg";
import img from "@assets/images/image.svg";
import infoIcon from "@assets/images/info.svg";
import MobileDesc2 from "@assets/images/info3.svg";
import iyugaLogo from "@assets/images/iyugalogo.svg";
import iyugaBetaLogo from "@assets/icons/iyugaBetaLogo.svg";
import leftSbBackIcon from "@assets/images/leftSbBackIcon.svg";
import linkError from "@assets/images/linkError.svg";
import linkSuccess from "@assets/images/linkSuccess.svg";
import LinksIconMobile from "@assets/images/links-icon-mobile.svg";
import loaderGif from "@assets/images/loader_gif.gif";
import MediaBlueIcon from "@assets/images/mediaBlueIcon.svg";
import messageIcon from "@assets/images/messageIcon.svg";
import miniMenu from "@assets/images/miniMenu.svg";
import MobileDesc from "@assets/images/mobileDesc.svg";
import MobileLogo from "@assets/images/mobileLogo.svg";
import mp3Icon from "@assets/images/mp3Icon.svg";
import Mwheelloader from "@assets/images/mwheelloader.svg";
import noBusinessbox from "@assets/images/noBusinessbox.svg";
import noPreview from "@assets/images/noPreview.svg";
import pdf from "@assets/images/pdf.svg";
import pdfIcon from "@assets/images/pdfIcon.svg";
import pencilEditIcon from "@assets/images/pencilEditIcon.svg";
import person from "@assets/images/person.svg";
import privateDark from "@assets/images/privateDark.svg";
import publicDark from "@assets/images/publicDark.svg";
import RotateLeft from "@assets/images/rotateLeft.svg";
import RotateRight from "@assets/images/rotateRight.svg";
import timeClock from "@assets/images/timeClock.svg";
import unlockDark from "@assets/images/unlockDark.svg";
import uploadMediaIcon from "@assets/images/uploadMediaIcon.svg";
import videoPlayer from "@assets/images/upload_video_icon.svg";
import DownArrow from "@assets/images/userdownarrow.svg";
import whitePencil from "@assets/images/whitePencil.svg";
import xls from "@assets/images/xls.svg";
import ppt from "assets/images/ppt.svg";
import youtubeIcon from "@assets/images/youtube (1) 1.png";
import youtubeicon from "@assets/images/youtubeicon.svg";
import jpeg from "assets/images/jpeg.svg";
import Account from "assets/images/settings/account.svg";
import Billing from "assets/images/settings/billing.svg";
import Data from "assets/images/settings/data.svg";
import Faq from "assets/images/settings/faq.svg";
import Feedback from "assets/images/settings/feedback.svg";
import Notifications from "assets/images/settings/notifications.svg";
import Password from "assets/images/settings/password.svg";
import PersonalSettings from "assets/images/settings/personal-settings.svg";
import Security from "assets/images/settings/security.svg";
import Session from "assets/images/settings/session.svg";
import sms from "assets/images/settings/sms.svg";
import SMSNew from "assets/images/settings/smsNew.svg";
import Subscription from "assets/images/settings/subscription.svg";
import Insurance from "assets/images/settings/insurance.svg";

import QrRefer from "@assets/images/QrRefer.svg";
import WheelMovbileBox from "@assets/images/WheelMovbileBox.svg";
import csv from "assets/images/csv.svg";
import ReferInvite from "@assets/images/referInvite.svg";

import InviteShare from "@assets/images/InviteShare.svg";

import ReferCopy from "@assets/images/ReferCopy.svg";
import Send from "@assets/images/Send.svg";

import Wallet from "@assets/images/wallet.svg";
import Withdrawal from "@assets/images/withdrawal.svg";

import WheelPantry from "@assets/images/WheelPantry.svg";
import Congratulations from "@assets/images/congratulations.svg";
import linkHorizontalIcon from "@assets/images/linkHorizontalIcon.svg";
import lockIcon from "@assets/images/lockIcon.svg";
import pantry from "@assets/images/pantry.svg";
import Sad from "@assets/images/sad.svg";
import shareSegmentIcon from "@assets/images/shareSegmentIcon.svg";
import usersListIcon from "@assets/images/supervised_user_circle.svg";
import EmptyDisplayImage from "../assets/images/EmptyDisplayImage.svg";
import defaultGrid from "../assets/images/default-grid.svg";
import masonryGrid from "../assets/images/masonry-grid.svg";
import quiltedGrid from "../assets/images/quilted-grid.svg";

import clone_green from "@assets/images/clone_green.svg";
import notification_autodeposit from "@assets/images/notification_autodeposit.svg";
import notification_bulb from "@assets/images/notification_bulb.svg";
import notification_clone from "@assets/images/notification_clone.svg";
import notification_collab from "@assets/images/notification_collab.svg";
import notification_expiry from "@assets/images/notification_expiry.svg";
import notification_follow from "@assets/images/notification_follow.svg";
import notification_heart from "@assets/images/notification_heart.svg";
import notification_live_clone from "@assets/images/notification_live_clone.svg";
import notification_lock from "@assets/images/notification_lock.svg";
import notification_message from "@assets/images/notification_message.svg";
import notification_red_storage from "@assets/images/notification_red_storage.svg";
import notification_share from "@assets/images/notification_share.svg";
import notification_tax from "@assets/images/notification_tax.svg";
import notification_unlock from "@assets/images/notification_unlock.svg";
import notification_warning from "@assets/images/notification_warning.svg";
import notification_yellow_storage from "@assets/images/notification_yellow_storage.svg";
import unlock_purple from "@assets/images/unlock_purple.svg";
import unlock_yellow from "@assets/images/unlock_yellow.svg";
// Start Segment Editors Icons
import Accordion from "@assets/images/segmentEditor/AccordionV2.svg";
import ImageGrid from "@assets/images/segmentEditor/ContainerV2.svg";
import ContentWidth from "@assets/images/segmentEditor/ContentWidth.svg";
import Divider from "@assets/images/segmentEditor/Divider.svg";
import EmptySegmentContainer from "@assets/images/segmentEditor/EmptySegmentContainer.svg";
import FullWidth from "@assets/images/segmentEditor/FullWidth.svg";
import GraphBlock from "@assets/images/segmentEditor/GraphBlock.svg";
import Header from "@assets/images/segmentEditor/Header.svg";
import ImageAbove from "@assets/images/segmentEditor/ImageAbove.svg";
import ImageBelow from "@assets/images/segmentEditor/ImageBelow.svg";
import Image from "@assets/images/segmentEditor/ImageV2.svg";
import ImageWithText from "@assets/images/segmentEditor/ImageWithTextV2.svg";
import Masonry from "@assets/images/segmentEditor/Masonry.svg";
import QuiltedImage from "@assets/images/segmentEditor/QuiltedImage.svg";
import SearchIcon from "@assets/images/segmentEditor/SearchIcon.svg";
import Text from "@assets/images/segmentEditor/TextV2.svg";
import Video from "@assets/images/segmentEditor/VideoV2.svg";
import WovenImage from "@assets/images/segmentEditor/WovenImage.svg";
import UploadImage from "@assets/images/segmentEditor/upload-image.svg";
import UploadVideo from "@assets/images/segmentEditor/upload-video.svg";
import EditImage from "assets/images/image-edit.svg";
import GridIcon from "assets/images/segmentEditor/GridIcon.svg";
import TableIcon from "assets/images/segmentEditor/TableIcon.svg";
import GridUpload from "assets/images/segmentEditor/GridUpload.svg";
import ReplaceAudio from "assets/images/replace-audio.svg";

import TextCenterAlign from "assets/images/center-align.svg";
import TextLeftAlign from "assets/images/left-align.svg";
import TextRightAlign from "assets/images/right-align.svg";

// Start Segment Editors Icons
import AddWheel from "@assets/images/segmentEditor/AddWheel.svg";
import AddWheelV2 from "@assets/images/segmentEditor/AddWheelV2.svg";
import AntiClockWise from "@assets/images/segmentEditor/AntiClockWise.svg";
import AtTheRate from "@assets/images/segmentEditor/AtTheRate.svg";
import BookIcon from "@assets/images/segmentEditor/BookIcon.svg";
import Bookmark from "@assets/images/segmentEditor/Bookmark.svg";
import SocialLinks from "assets/images/social-links.svg";
import Social from "assets/images/social.svg";
import ClockWise from "@assets/images/segmentEditor/ClockWise.svg";
import CloneIcon from "@assets/images/segmentEditor/CloneIcon.svg";
import document from "assets/images/document.svg";
import Document from "assets/images/segmentEditor/document.svg";
import Document2 from "assets/images/segmentEditor/document2.svg";
import CloneWheel from "@assets/images/segmentEditor/CloneWheel.svg";
import ContainerSetting from "@assets/images/segmentEditor/ContainerSetting.svg";
import CopyIcon from "@assets/images/segmentEditor/CopyIcon.svg";
import DeleteIcon from "@assets/images/segmentEditor/DeleteIcon.svg";
import DeleteOutline from "@assets/images/segmentEditor/DeleteOutline.svg";
import Description from "@assets/images/segmentEditor/Description.svg";
import DummyPattern from "@assets/images/segmentEditor/DummyPattern.svg";
import Edit from "@assets/images/segmentEditor/Edit.svg";
import EditPencil from "@assets/images/segmentEditor/EditPencil.svg";
import EditPencilV2 from "@assets/images/segmentEditor/EditPencilV2.svg";
import EmptyWheelListing from "@assets/images/segmentEditor/EmptyWheelListing.svg";
import FacebookIcon from "@assets/images/segmentEditor/FacebookIcon.svg";
import FacebookIconV2 from "@assets/images/segmentEditor/FacebookIconV2.svg";
import FilterIcon from "@assets/images/segmentEditor/FilterIcon.svg";
import GridV2 from "@assets/images/segmentEditor/GridV2.svg";
import GridV3 from "@assets/images/segmentEditor/GridV3.svg";
import GridV4 from "@assets/images/segmentEditor/GridV4.svg";
import AudioRecorder from "assets/images/audio-recorder.svg";
import Home from "@assets/images/segmentEditor/Home.svg";
import ImageTitleImage from "@assets/images/segmentEditor/ImageTitleImage.svg";
import InstagramIcon from "@assets/images/segmentEditor/InstagramIcon.svg";
import LeftAlign from "@assets/images/segmentEditor/LeftAlign.svg";
import LikeIcon from "@assets/images/segmentEditor/LikeIcon.svg";
import LinkIcon from "@assets/images/segmentEditor/LinkIcon.svg";
import LinkWheelIcon from "@assets/images/segmentEditor/LinkWheelIcon.svg";
import List from "@assets/images/segmentEditor/List.svg";
import ListIcon from "@assets/images/segmentEditor/ListIcon.svg";
import SuggestionIcon from "assets/images/suggestion.svg";
import ListV2 from "@assets/images/segmentEditor/ListV2.svg";
import ListV3 from "@assets/images/segmentEditor/ListV3.svg";
import LiveShare from "@assets/images/segmentEditor/LiveShare.svg";
import LiveShareV2 from "@assets/images/segmentEditor/LiveShareV2.svg";
import LockWheel from "@assets/images/segmentEditor/LockWheel.svg";
import MessengerIcon from "@assets/images/segmentEditor/MessengerIcon.svg";
import MusicNode from "@assets/images/segmentEditor/MusicNode.svg";
import NotificationIcon from "@assets/images/segmentEditor/NotificationIcon.svg";
import Pantry from "@assets/images/segmentEditor/Pantry.svg";
import SegmentLibrary from "@assets/images/segmentEditor/SegmentLibrary.svg";
import PincentIcon from "@assets/images/segmentEditor/PincentIcon.svg";
import PincentIconV2 from "@assets/images/segmentEditor/PincentIconV2.svg";
import Plus from "@assets/images/segmentEditor/Plus.svg";
import PrivateWheel from "@assets/images/segmentEditor/PrivateWheel.svg";
import ProfileLogo from "@assets/images/segmentEditor/ProfileLogo.svg";
import PublicWheel from "@assets/images/segmentEditor/PublicWheel.svg";
import ColorPicker from "assets/images/color-picker.svg";
import QuillPen from "@assets/images/segmentEditor/QuillPen.svg";
import ReloadIcon from "@assets/images/segmentEditor/ReloadIcon.svg";
import ReplaceImage from "@assets/images/segmentEditor/ReplaceImage.svg";
import LoginPortrait from "@assets/images/login-portrait.png";
import LoginTablet from "@assets/images/login-landscape.png";
import RightAlign from "@assets/images/segmentEditor/RightAlign.svg";
import Sample_Business from "@assets/images/segmentEditor/Sample_Business.svg";
import Save from "@assets/images/segmentEditor/Save.svg";
import SearchV2 from "@assets/images/segmentEditor/SearchV2.svg";
import Segment from "@assets/images/segmentEditor/Segment.svg";
import SegmentIconV2 from "@assets/images/segmentEditor/SegmentIconV2.svg";
import SegmentSampleIcon from "@assets/images/segmentEditor/SegmentSampleIcon.svg";
import Setting from "@assets/images/segmentEditor/Setting.svg";
import Copilot from "@assets/images/segmentEditor/Copilot.svg";
import Capture from "@assets/images/segmentEditor/Capture.svg";
import ShareIcon from "@assets/images/segmentEditor/ShareIcon.svg";
import ShareIconV2 from "@assets/images/segmentEditor/ShareIconV2.svg";
import Speaker from "@assets/images/segmentEditor/Speaker.svg";
import TwitterIcon from "@assets/images/segmentEditor/TwitterIcon.svg";
import TwitterIconV2 from "@assets/images/segmentEditor/TwitterIconV2.svg";
import TypographyIcon from "@assets/images/segmentEditor/TypographyIcon.svg";
import UkIcon from "@assets/images/segmentEditor/UkIcon.svg";
import View from "@assets/images/segmentEditor/View.svg";
import ViewV2 from "@assets/images/segmentEditor/ViewV2.svg";
import YoutubeIcon from "@assets/images/segmentEditor/YoutubeIcon.svg";
import ContainerWallpaper from "@assets/images/segmentEditor/containerWallpaper.svg";
import comingSoonV2 from "@assets/images/segmentEditor/comingSoonV2.svg";
import OldWheels from "@assets/images/segmentEditor/OldWheels.svg";
import Folder from "@assets/images/segmentEditor/Folder.svg";
import Incognito from "@assets/images/segmentEditor/Incognito.svg";
import LockWheelEmailListIcon from "@assets/images/segmentEditor/LockWheelEmailListIcon.svg";
import EmptyNestedFolder from "@assets/images/segmentEditor/EmptyNestedFolder.svg";
import RemoveFromFolder from "@assets/images/segmentEditor/RemoveFromFolder.svg";
import AddFolder from "@assets/images/segmentEditor/AddFolder.svg";
import ButtonBlock from "@assets/images/segmentEditor/ButtonBlock.svg";
import EmptyFolder from "@assets/images/segmentEditor/EmptyFolder.svg";
import PrimaryFolder from "@assets/images/segmentEditor/PrimaryFolder.svg";
import PrivateFolder from "@assets/images/segmentEditor/PrivateFolder.svg";
import PrivateVisible from "@assets/images/segmentEditor/PrivateVisible.svg";
import DummySocial from "assets/images/dummy-social.svg";
import PublicFolder from "@assets/images/segmentEditor/PublicFolder.svg";
import PublicVisible from "@assets/images/segmentEditor/PublicVisible.svg";
import CenterAlignment from "@assets/images/segmentEditor/centerAlignment.svg";
import DefaultWallpaperForViewWheel from "@assets/images/segmentEditor/defaultWallpaperForViewWheel.svg";
import LeftAlignment from "@assets/images/segmentEditor/leftAlignment.svg";
import RightAlignment from "@assets/images/segmentEditor/rightAlignment.svg";
import TimeoutPopupWheel from "@assets/images/timeoutpopupwheel.svg";
import GDocs from "assets/images/g-docs.svg";
import GSlides from "assets/images/g-slides.svg";
import GSheets from "assets/images/g-sheets.svg";
import GForms from "assets/images/g-forms.svg";
import GDrive from "assets/images/g-drive.svg";
import OneDrive from "assets/images/onedrive.svg";
import StorageAudio from "assets/images/storageAudio.svg";
import AIWheelProgress1 from "assets/images/AI-progress-1.svg";
import AIWheelProgress2 from "assets/images/AI-progress-2.svg";
import AIWheelProgress3 from "assets/images/AI-progress-3.svg";
import UserSearchThumb from "assets/images/User-search-thumb.svg";

import NewAiIcon from "assets/images/newAiIcon.svg";
import Premium from "assets/images/Premium.svg";
import BlueStorage from "assets/images/BlueStorage.svg";

import ContentModeration from "assets/images/contentmoderation.svg";

import IyugaWhiteLogo from "@assets/images/Iyuga_logo_white_bg.svg";
// ISP-4018 (DL-002, §12 WHEEL-WITHOUT-PORTRAIT law): the colored iYuga company
// logo shown in a Wheel's center when it has no portrait. Same asset the shared
// render engine (D3Wheels/createPie.js) falls back to, so every no-portrait
// surface shows one consistent mark — never a user-silhouette placeholder.
// #920e §2 — the empty-collection / no-portrait default mark. Was iyuga.jpg, a
// heavily-compressed 34KB JPEG (visible artifacts, wide 1801x1330 aspect that a
// circular object-fit:cover cropped). Swapped to the SVG-wrapped brand mark
// (crisp at any DPR, near-square, ~7x the source-image data) so the empty-state
// logo is no longer low-resolution. Default import = the built asset URL under
// CRA/craco's SVGR config, so `wheelLogoFallback` stays a URL string.
import DefaultIyugaLogo from "@assets/images/iyugalogo.svg";

// Start Segment Editors Icons
import PopupLogo from "@assets/images/popup-logo.svg";

import EnterBeta from "@assets/images/EnterBeta.png";
import WantIn from "@assets/images/WantIn.png";
//Autosaving icons
import Saving from "@assets/images/Saving.png";
import UnsavedChanges from "@assets/images/UnsavedChanges.svg";
import OnlySave from "@assets/images/OnlySave.svg";

import Audio from "assets/images/segmentEditor/audio.svg";
import DialogImg from "@assets/images/DialogImg.svg";
import LableToggleIconMobile from "@assets/images/LabelToggleIcon_mobile.svg";
import LableToggleIconMobileFilled from "@assets/images/LabelToggleIcon_mobile_filled.svg";
import SegmentSettingsIcon from "@assets/images/SegmentSettingsIcon.svg";
import CloneModalIcon from "@assets/images/segmentEditor/CloneModalIcon.svg";
import BroadCastIcon from "@assets/images/BroadcastIcon.svg";
import BroadCastUpdateYellowIcon from "@assets/images/liveCloneUpdateAvailable.svg";
import CloningDisabled from "@assets/images/CloningDisabled.svg";
import NewDoc from "@assets/images/newDoc.svg";
import userimg from "@assets/images/userimg.svg";
import JustMessenger from "@assets/images/JustMessenger.svg";
import Sync2 from "@assets/icons/Sync.svg";
import SyncWarning from "@assets/icons/SyncWarning.svg";
import SyncError from "@assets/icons/SyncError.svg";

//Hotbar icons
import ImagesIcon from "@assets/images/ImagesIcon.svg";
import VideosIcon from "@assets/images/VideosIcon.svg";
import DocumentsIcon from "@assets/images/DocumentsIcon.svg";
import AudiosIcon from "@assets/images/AudiosIcon.svg";
import LinksIcon_hotbar from "@assets/images/LinksIcon_hotbar.svg";
import premiumWheel from "@assets/images/premium-wheel.svg";
// import { formatDate } from "./helpers";

import CreatedTabEmptyState from "@assets/images/CreatedTabEmptyState.svg";
import ClonedTabEmptyState from "@assets/images/ClonedEmptyState.svg";
import UnlockedTabEmptyState from "@assets/images/UnclockEmptyState.svg";
import FavouritedTabEmptyState from "@assets/images/FavouriteEmptyState.svg";
import InviteBtn from "@assets/images/InviteBtn.png";
import PrimaryWheelPlaceholder from "@assets/images/PrimaryWheelPlaceholder.svg";

// export const API_BASE_PATH = 'https://yuga-36787-staging.botics.co/'
export const API_BASE_PATH = process.env.REACT_APP_BASE_URL;
export const csrfToken = process.env.REACT_APP_CSRF_TOKEN;
export const sessionId = process.env.REACT_APP_SESSION_ID;

// --- AI Builder Stage 2 feature flag (additive, DEFAULT OFF). Mirrors the
// backend gate AI_BUILDER_STAGE2_ENABLED (Backend PR #1169). When OFF the new
// website-crawl + scope-proposal flow is never rendered and the existing AI
// Wheel Builder behaves exactly as before. Even when the UI flag is ON, the
// backend routes still 404 unless the backend flag is also ON — they must be
// flipped together. ---
export const AI_BUILDER_STAGE2_ENABLED =
  process.env.REACT_APP_AI_BUILDER_STAGE2 === "true";

// --- AI Builder Stage 3 feature flag (additive, DEFAULT OFF). Mirrors the
// backend gate AI_BUILDER_STAGE3_ENABLED (Backend PR #1175 / branch
// claude/ai-builder-stage3). When OFF the new "From your photos" media-input
// flow is never rendered and the existing AI Wheel Builder behaves exactly as
// before. Even when the UI flag is ON, the backend route still 404s unless the
// backend flag is also ON — they must be flipped together. ---
export const AI_BUILDER_STAGE3_ENABLED =
  process.env.REACT_APP_AI_BUILDER_STAGE3 === "true";

// --- Phone / SMS OTP delivery option (D-21, Terry 2026-07-28 QA-23). DEFAULT OFF. ---
// Outbound SMS delivery does not work today, so the app must never OFFER "send my
// code to my phone" — an option that silently never delivers strands the user
// mid-recovery. When OFF: the Forgot-Password channel chooser is skipped (email OTP
// only) and the Settings > Account "SMS Authentication" 2FA section is not rendered.
// The email OTP path is untouched in every flow, and ordinary phone INPUT fields
// (signup/profile, D-16) are unaffected — this gates only the send-a-code-to-my-phone
// option. Flip REACT_APP_PHONE_OTP=true the moment SMS sending works.
// WARNING: this is a documented EXCEPTION to the staging-flags-always-on policy —
// classify BUILT-BROKEN and leave OFF on staging and prod until SMS is verified.
export const PHONE_OTP_ENABLED = process.env.REACT_APP_PHONE_OTP === "true";

// Feature flag: Wheel commenting (v1, whole-wheel). Ships DARK — absent env var => false => fully inert.
// Convention mirrors REACT_APP_RECAPTCHA_ENABLED (src/contexts/RecaptchaContext.jsx).
export const COMMENTS_ENABLED = process.env.REACT_APP_COMMENTS_ENABLED === "true";

// --- Chat voice notes + mic dictation (ISP-9999, Gordon-approved 2026-08-19). DEFAULT OFF. ---
// Gates BOTH sub-features as one unit: (1) recording + sending a voice-note attachment via
// MediaRecorder, reusing the EXISTING chat attachment upload path (services/chat.js
// sendMessage's multipart `attachment` param — same code path as a Photo send, see
// Composer.jsx); (2) mic dictation into the message text box via the browser-native
// SpeechRecognition API. When OFF, neither mic button renders and Composer behaves exactly
// as before. DEPENDS ON: BE #2513 (non-image moderation) before this can go live on any
// environment with real users — until then, the backend's `_moderate_rekognition` gate
// FAIL-CLOSES any non-image attachment (see ATTACHMENT_MAX_BYTES comment, Chat.helpers.js),
// so a sent voice note would 400 server-side even with this flag ON. Flip
// REACT_APP_VOICE_NOTES=true on staging only after BE #2513 is deployed there.
export const VOICE_NOTES_ENABLED = process.env.REACT_APP_VOICE_NOTES === "true";

export const API_PATH = {
  // --- Developer public-API keys portal (consumes public-api-stage2) ---
  PUBLIC_API_KEYS: "/v1/keys/", // GET list, POST issue
  PUBLIC_API_KEY_DETAIL: (keyId) => `/v1/keys/${keyId}/`, // DELETE revoke
  PUBLIC_API_KEY_USAGE: (keyId) => `/v1/keys/${keyId}/usage/`, // GET per-key usage/quota
  CHECK_PERMISSIONS: "/subscription/permissions/",
  LOGIN: "/api/v1/login/",
  // FEAT-L9 passkeys/WebAuthn (backend PR #2820 + #2827).
  PASSKEY_REGISTRATION_OPTIONS: "/api/v1/login/passkey/registration_options/",
  PASSKEY_REGISTRATION_VERIFY: "/api/v1/login/passkey/registration_verify/",
  PASSKEY_AUTHENTICATION_OPTIONS: "/api/v1/login/passkey/authentication_options/",
  PASSKEY_AUTHENTICATION_VERIFY: "/api/v1/login/passkey/authentication_verify/",
  PASSKEY_CREDENTIALS: "/api/v1/login/passkey/credentials/", // GET list
  PASSKEY_CREDENTIAL_DETAIL: (id) => `/api/v1/login/passkey/credentials/${id}/`, // DELETE
  LOGOUT: "/api/v1/logout/",
  SIGN_UP: "/api/v1/signup/",
  VERIFY_EMAIL_LINK: "/api/v1/verify_email/",
  RESEND_VERIFICATION_LINK: "/api/v1/resend_verification/",
  DISCOUNT_CODE: "api/v2/promo-code-email/",
  VERIFY_EMAIL_OTP: "/api/v1/verify_email_otp/",
  VERIFY_PHONE_OTP: "/api/v1/verify_phone_otp/",
  SEND_EMAIL_OTP: "/api/v1/send_email_otp/",
  SEND_PHONE_OTP: "/api/v1/send_phone_otp/",
  FORGOT_VERIFY_EMAIL_OTP: "/api/v1/forgot_password/verify_email_otp/",
  FORGOT_VERIFY_PHONE_OTP: "/api/v1/forgot_password/verify_phone_otp/",
  FORGOT_SEND_EMAIL_OTP: "/api/v1/forgot_password/send_email_otp/",
  FORGOT_SEND_PHONE_OTP: "/api/v1/forgot_password/send_phone_otp/",
  // Login L4 -- passwordless email magic-link (flag-gated, see magicLinkFlag.js).
  MAGIC_LINK_SEND: "/api/v1/login/magic_link/send/",
  MAGIC_LINK_REDEEM: "/api/v1/login/magic_link/redeem/",
  VERIFY_PASSWORD: "/api/v1/validate_password/",
  REMOVE_PHONE_2FA: "/api/v1/remove_phone/",
  // Permanent account deletion (destructive). DELETE with a JSON body
  // { password?, reason }. Mirrors the existing mobile RN + backend
  // DeleteAccountView contract (home/api/v1/viewsets.py:DeleteAccountView).
  DELETE_ACCOUNT: "/api/v1/delete-account/",
  RESET_PASSWORD: "/api/v1/forgot_password/reset_password/",
  GET_WHEEL_HOME_VIEW: "/wheel/home_view",
  // stgfix-1008-B62-texted-copied-invite-and-gallery-share-links-previ: a
  // backend-rendered OG/Twitter card (Backend
  // home/api/v2/viewsets/gallery_share_view.py) so a texted/copied Gallery
  // link unfurls with the owner's real name/picture instead of the bare SPA
  // route's generic static card.
  GALLERY_SHARE: (userId) => `/api/v2/gallery/share/${userId}/`,
  GET_ALL_CATEGORIES: "/api/v1/category/",
  GET_ALL_TAGS: "/api/v1/tags/",
  WHEEL_SEARCH: "/wheel/search/",
  AUTO_GENERATE_WHEEL: "/wheel/wheel-generate/",
  GENERATE_AI_WHEEL: "/api/v2/wheel/wheel-generate-premium/",
  // AI Wheel Lab (gordon-0923-P1, DEV-ONLY staff multimodel bake-off) — same
  // prefix as GENERATE_AI_WHEEL, same wheel viewset. Backend PR #3402
  // (branch gordon0923-ai-wheel-lab-multimodel, base DevOps-Dev) — flag-gated
  // AI_WHEEL_LAB_ENABLED server-side (404 while off, identical to a
  // nonexistent route), staff-only (403 for an authenticated non-staff user).
  // Pairs with REACT_APP_AI_WHEEL_LAB_ENABLED (src/constants/featureFlags.js).
  AI_WHEEL_LAB_ESTIMATE: "/api/v2/wheel/wheel-ai-lab-estimate/",
  AI_WHEEL_LAB_GENERATE: "/api/v2/wheel/wheel-ai-lab-generate/",
  // --- AI Builder Stage 2 (additive, flag-gated REACT_APP_AI_BUILDER_STAGE2;
  // backend gated behind AI_BUILDER_STAGE2_ENABLED — both routes return 404
  // when their flag is OFF). Contract: Backend PR #1169 / branch
  // claude/ai-builder-stage2. ---
  // Crawl a URL + return a never-blank scope proposal (outline) to confirm.
  AI_BUILDER_CRAWL_PROPOSE: "/api/v2/wheel/wheel-ai-crawl-propose/",
  // Generate the full wheel after the user confirms/edits the proposed outline.
  AI_BUILDER_GENERATE_STAGE2: "/api/v2/wheel/wheel-ai-generate-stage2/",
  // --- AI Builder Stage 3 (additive, flag-gated REACT_APP_AI_BUILDER_STAGE3;
  // backend gated behind AI_BUILDER_STAGE3_ENABLED — the route returns 404 when
  // its flag is OFF). Contract: Backend PR #1175 / branch
  // claude/ai-builder-stage3. ---
  // Vision-describe the supplied photos + return a never-blank Stage-1 wheel
  // payload plus a media_summary of what the AI saw.
  AI_BUILDER_GENERATE_STAGE3: "/api/v2/wheel/wheel-ai-generate-stage3/",
  // AI Wheel Builder staged funnel (D14) — gated behind REACT_APP_AI_FUNNEL on
  // the client and AI_FUNNEL_ENABLED on the server (both default OFF).
  AI_FUNNEL_SCRAPE: "/api/v2/wheel/ai-funnel-scrape/",
  AI_FUNNEL_ESTIMATE: "/api/v2/wheel/ai-funnel-estimate/",
  WHEEL_COPILOT: "/api/v2/wheel/copilot/",
  GET_LATEST_AI_WHEEL: (temp_id) =>
    `/wheel/get-wheel-generate/?temp_id=${temp_id}`,
  GET_USER_WHEELS_BY_ID: (user_id, query) =>
    `/wheel/v3/user/${user_id}/?page_size=40${query ? query : ""}`,
  GET_USER_WHEELS_BY_ID_V2: (query) => `/api/v2/wheel/${query}`, // should be changed to `/wheel/user/${user_id}/` after getting pagination approval
  GET_USER_PROFILE_BY_ID: (user_id) => `/api/v1/user/${user_id}/profile/`,
  FOLLOW_STATUS: (user_id) => `/api/v1/user/${user_id}/follow-status/`,
  FOLLOW_USER: (user_id) => `/api/v1/user/${user_id}/follow/`,
  UNFOLLOW_USER: (user_id) => `/api/v1/user/${user_id}/unfollow/`,
  // Followers/Following list endpoints (support search via query params)
  GET_USER_FOLLOWERS: (user_id) => `/api/v1/user/${user_id}/followers/`,
  GET_USER_FOLLOWING: (user_id) => `/api/v1/user/${user_id}/following/`,
  GET_WHEEL_AUTHORS: (wheel_id) => `/wheel/${wheel_id}/clones/`,
  GET_WHEEL_DETIALS: (wheel_id) => `/api/v2/wheel/${wheel_id}/`,
  // feat-0923-broken-media-alerts contract (SPEC.md): owner-only list of this
  // wheel's currently-broken assigned media, the summary used to compute the
  // header indicator's count, and the client-side report endpoint any viewer
  // (authed or anon) hits on an image/video load error.
  GET_WHEEL_BROKEN_MEDIA: (wheel_id) => `/api/v2/wheel/${wheel_id}/broken-media/`,
  GET_BROKEN_MEDIA_SUMMARY: () => `/api/v2/users/me/broken-media/summary/`,
  POST_BROKEN_MEDIA_REPORT: () => `/api/v2/media/broken-report/`,
  GET_USER_WHEELS: (user_id, query) =>
    `/api/v2/wheel/?page_size=40&add_primary=true&user_id=${user_id}${
      query ? query : ""
    }`,
  GET_MEDIA_BROWSER_DATA: (text, type, source, page, per_page) =>
    `/wheel/get-media/?search=${text}&type=${type}&source=${source}&page=${page}&per_page=${per_page}`, // should be changed to `/wheel/user/${user_id}/` after getting pagination approval

  // GET_MEDIA_BROWSER_DATA_v2: (text, type, source, page, per_page) =>
  //   `/api/v2/wheel/get-media/?search=${text}&type=${type}&source=${source}&page=${page}&per_page=${per_page}`,
  GET_MEDIA_BROWSER_DATA_v2: (
    text,
    type,
    source,
    page,
    per_page,
    offset,
    limit
  ) =>
    `/api/v2/wheel/get-media/?search=${text}&type=${type}&source=${source}${
      offset !== undefined && limit !== undefined
        ? `&offset=${offset}&limit=${limit}` // For GIF requests (offset and limit)
        : `&page=${page}&per_page=${per_page}` // Default case (page and per_page)
    }`,

  USER_UPDATE_PROFILE: "/api/v1/user/update-profile/",
  CREATE_WHEEL: "/wheel/",
  CREATE_WHEEL_V2: "api/v2/wheel/",
  UPDATE_WHEEL_V2: (wheel_id) => `api/v2/wheel/${wheel_id}/`,
  SUBMIT_FEEDBACK: "/api/v1/user/feedback/",
  GET_WHEEL_SECTION: (wheel_id) => `/wheel/${wheel_id}/section/`,
  GET_WHEEL: (wheel_id) => `/wheel/${wheel_id}/`,
  GET_PRIMARY_WHEEL: `/wheel/primary/`,
  UPLOAD_WHEEL_IMAGE: (wheel_id) => `/wheel/${wheel_id}/image/`,
  EDIT_WHEEL: (wheel_id) => `/wheel/${wheel_id}/`,
  DELETE_WHEEL: (wheel_id) => `/wheel/${wheel_id}/`,
  GOOGLE_LOGIN: "/api/v1/social/google/login/",
  FACEBOOK_LOGIN: "/api/v1/social/facebook/login/",
  APPLE_LOGIN: "/api/v1/social/apple/login/",
  UPDATE_PRIMARY_WHEEL: (wheel_id) => `/wheel/${wheel_id}/update-primary/`,
  UPDATE_WHEEL_VISIBILITY: (wheel_id) =>
    `/wheel/${wheel_id}/update-visibility/`,
  UPDATE_WHEEL_VISIBILITY_V2: (wheel_id) =>
    `api/v2/wheel/${wheel_id}/update-visibility/`,
  // Roadmap #7 — owner opt-in toggle to make a public wheel embeddable.
  SET_WHEEL_EMBEDDING: (wheel_id) => `api/v2/wheel/${wheel_id}/embedding/`,

  REMOVE_PRIMARY_WHEEL: "/wheel/remove-primary/",

  CLONE_WHEEL: (wheel_id) => `api/v2/wheel/${wheel_id}/clone/`,
  LIKE_UNLIKE_WHEEL: (wheel_id) => `api/v2/wheel/${wheel_id}/like-unlike/`,
  // WL-043 — Wheel version history (server-side history + rollback)
  WHEEL_VERSIONS: (wheel_id) => `/api/v2/wheel/${wheel_id}/versions/`,
  WHEEL_VERSION_NAME: (wheel_id) => `/api/v2/wheel/${wheel_id}/versions/name/`,
  WHEEL_VERSION_RESTORE: (wheel_id) => `/api/v2/wheel/${wheel_id}/versions/restore/`,
  GET_MY_CUSTOM_COLORS: () => `/api/v1/custom-color/`,
  ADD_MY_CUSTOM_COLORS: () => `/api/v1/custom-color/`,
  EDIT_MY_CUSTOM_COLORS: (id) => `/api/v1/custom-color/${id}/`,

  REFERRAL_INVITES_API: () => "/api/v1/referrals/email-invite",
  DOWNLOAD_REFERRALS_REPORT: (query) =>
    `/api/v1/referrals/download-report/${query}`,
  GET_ANALYTICS_DETAIL: `/wheel/wheel-analytics-detail/`,
  // WL-019 Creator Analytics — existing yuga_wheel metrics endpoints served today.
  CREATOR_STATS: `/wheel/user/stats/`,
  CREATOR_WHEEL_ANALYTICS: `/wheel/user/analytics/`,
  CREATOR_HALL_OF_FAME: `/wheel/user/hall-of-fame/`,
  // gordon-0923-P1-analytics-charts-over-time (ADDENDUM 2): day-by-day
  // account/per-wheel series backing AccountTimeseriesChart. Backend PR
  // #3427 (base DevOps-Dev, contract final, not yet merged).
  ANALYTICS_TIMESERIES: `/wheel/user/analytics/timeseries/`,
  GET_HALL_OF_FAME: (filter, startDate, endDate) => {
    let url = "/api/v1/referrals/hall-of-fame/";

    if (filter) {
      url += `?time_period=${filter}`;

      if (filter === "date" && startDate && endDate) {
        const formattedStartDate = `${startDate.getFullYear()}-${
          startDate.getMonth() + 1
        }-${startDate.getDate()}`;
        const formattedEndDate = `${endDate.getFullYear()}-${
          endDate.getMonth() + 1
        }-${endDate.getDate()}`;

        url += `&start_date=${formattedStartDate}&end_date=${formattedEndDate}`;
      }
    }
    return url;
  },
  GET_FOLLOWERS_GAINED: (filter, startDate, endDate) => {
    let url = "/api/v1/user/followers-gained/";

    if (filter) {
      url += `?time_period=${filter}`;

      if (filter === "date" && startDate && endDate) {
        const formattedStartDate = `${startDate.getFullYear()}-${
          startDate.getMonth() + 1
        }-${startDate.getDate()}`;
        const formattedEndDate = `${endDate.getFullYear()}-${
          endDate.getMonth() + 1
        }-${endDate.getDate()}`;

        url += `&start_date=${formattedStartDate}&end_date=${formattedEndDate}`;
      }
    }
    return url;
  },
  AVIF_T0_PNG: "/api/v2/wheel/avif-to-png/",
  GET_ALL_SUBSCRIPTION: "subscription/packages/",
  GET_ACTIVE_SUBSCRIPTION: "/subscription/packages/active/",
  CAN_CREATE_WHEEL: "/subscription/create-wheel/",
  CAN_CLONE_WHEEL: "/subscription/clone-wheel/",
  DOWNLOAD_INVOICE: "/payments/transaction-history/download-invoice/",
  GET_SUBSCRIPTION_DETAILS: (subscription_id) =>
    `subscription/packages/${subscription_id}/`,
  PURCHASE_SUBSCRIPTION: "/payments/purchase-subscription/",
  // ISP-9999 (Option B4) -- flag-gated 404 until settings.ENTITLEMENT_LEDGER_ENABLED.
  MOVE_PLAN: "/subscription/move-plan/",
  CANCEL_SUBSCRIPTION: "/payments/cancel-subscription/",
  SYNC_SUBSCRIPTION: "/payments/sync-subscription/",
  CANCEL_SCHEDULED_SUBSCRIPTION_CHANGE:
    "/payments/change-subscription/cancel-scheduled-change/",
  COMPARE_SUBSCRIPTION: "/subscription/packages/compare/",
  CHANGE_SUBSCRIPTION: "/payments/change-subscription/",
  // T22.243: no transaction_purpose filter -- Payment history lists EVERY charge
  // (renewals, upgrades, paid-lock unlocks, refunds), not only SUBSCRIPTION rows.
  GET_ALL_TRANSACTIONS: (startDate, endDate, limit = 10, offset = 0) =>
    `/payments/transaction-history/?limit=${limit}&offset=${offset}${
      startDate ? `&date_range_after=${startDate}` : ""
    }${endDate ? `&date_range_before=${endDate}` : ""}`,
  ADD_CARD: "/payments/add-card/",
  DELETE_CARD: "/payments/remove-card/",
  LIST_ALL_CARDS: "/payments/list-card/",
  SET_DEFAULT_CARD: "/payments/default-card/",
  CHANGE_PASSWORD: "/api/v1/change_password/",
  SEND_FEEDBACK: (user_id) => `/api/v1/user/${user_id}/feedback/`,
  CREATE_BUSINESSBOX: "/api/v1/business-box/",
  CREATE_BUSINESSBOXV2: "/api/v2/business-box/",
  SUBMIT_REPORT: "/api/v1/report/",
  GET_BUSINESSBOXV2: (user_id) => `/api/v2/business-box/?user=${user_id}`,
  GET_BUSINESSBOX: (user_id) => `/api/v1/business-box/user/${user_id}/`,
  UPDATE_BUSINESSBOX_PROFILE: (user_id) =>
    `/api/v1/business-box/${user_id}/profile/`,
  GET_PRIMARY_BUSINESSBOX: (user_id) =>
    `/api/v1/business-box/primary/?user_id=${user_id}`,
  UPDATE_BUSINESSBOX: (id) => `/api/v1/business-box/${id}/`,
  UPDATE_BUSINESSBOX_V2: (id) => `/api/v2/business-box/${id}/`,
  UPDATE_PRIMARY_BUSINESSBOX: (id) => `/api/v2/business-box/${id}/profile/`,
  UNLOCK_WHEEL: (id) => `/wheel/${id}/user-wheel-unlock/`,
  // Lead Inbox (inspiration I1, spec LEAD-INBOX-spec.md §4.5). Owner-scoped
  // list + CSV export of captured lead rows (UserWheelUnlock). `qs` is a
  // pre-built query string (page/page_size/wheel_id/q/date_from/date_to/source).
  // BE route is registered only while the backend LEAD_INBOX_ENABLED flag is ON;
  // otherwise both 404 and the flag-ON tab shows its standard error state.
  GET_LEADS: (qs = "") => `/api/v2/wheel/leads/${qs ? `?${qs}` : ""}`,
  EXPORT_LEADS: (qs = "") => `/api/v2/wheel/leads/export/${qs ? `?${qs}` : ""}`,
  // CLONE_WHEEL: (id) => `/wheel/${id}/copy/`,
  DUPLICATE_WHEEL: (WheelID) => `/wheel/${WheelID}/copy/`,
  UPLOAD_IMAGE: "/api/v2/wheel/upload-segment-image/",
  CLONE_SEGMENT: (id) => `/wheel/activity/${id}/copy/`,
  // SEGMENT LOCK §2 — per-segment unlock. BE-gated by SEGMENT_LOCK_ENABLED (404 while
  // OFF). POST body {password} for a password lock; email->403, paid->402+price.
  UNLOCK_SEGMENT: (id) => `/wheel/activity/${id}/unlock/`,
  // SEGMENT COLLECT §1 — list the current user's collected segments (hollow-wheel
  // render). BE-gated by SEGMENT_COLLECT_ENABLED (404 while OFF).
  SEGMENT_COLLECTIONS: (page = 1, page_size = 12) =>
    `/wheel/collections/?page=${page}&page_size=${page_size}`,
  // The query is USER INPUT and must be percent-encoded before it is
  // interpolated into the URL. Unencoded, a `#` starts the fragment (the server
  // never sees the rest of the URL — `!@#$%^&*()` shipped as `?search=!@`,
  // silently dropping `page`/`page_size` too), `&` forges a new query param and
  // `%` can form an invalid escape. Measured on web-stg 2026-07-24.
  GENERAL_SEARCH: (text) => `/api/v2/search/?search=${encodeURIComponent(text ?? "")}`,
  SEARCH_USERS: (search, page, page_size) =>
    `/api/v2/search-users/?search=${encodeURIComponent(
      search ?? ""
    )}&page=${page}&page_size=${page_size}`,
  SEARCH_WHEELS: (search, page, page_size) =>
    `/api/v2/search-wheels/?search=${encodeURIComponent(
      search ?? ""
    )}&page=${page}&page_size=${page_size}`,
  CREATE_SETUP_INTENT: "payments/create-setup-intent/",
  GET_FAQ: "modules/faq/",
  // Help / FAQ surface (#14): in-app contact form -> support@iyuga.net.
  // 🟡 BACKEND: confirm/implement this endpoint. Until it exists the contact
  // form surfaces a graceful error and points the user at the support email.
  SUBMIT_SUPPORT_REQUEST: "/api/v1/support/contact/",
  GET_USER_PRIVATE_WHEELS_BY_ID: (user_id) =>
    `/wheel/user/${user_id}/?visibility=2&page_size=6`,
  GET_USER_UNLOCKED_WHEELS_BY_ID: (user_id) =>
    `/wheel/user/${user_id}/?mode=unlock&page_size=6`,
  GET_USER_CLONED_WHEELS_BY_ID: (user_id) =>
    `/wheel/user/${user_id}/?mode=clone&page_size=6`,
  GET_USER_CLONED_SEGMENTS_BY_ID: `/wheel/copied/segments/?page_size=6`,
  GET_ALL_WALLPAPERS: "/api/v1/wheel-wallpaper/?limit=30",
  REFERRAL_AMBASSADOR: "/api/v1/referrals/ambassadors/",
  REFERRAL_BT: "/api/v1/referrals/bt-referrals/",
  REFERRAL_DIRECT: "/api/v1/referrals/direct-referrals/",
  REFERRAL_INVITES: "/api/v1/referrals/email-invite",
  ANALYTICS: "/api/v1/referrals/analytics/",
  REFERRAL_CHART: (category, time) =>
    `/api/v1/referrals/chart/?category=${category}&time_frame=${time}`,
  PAYMENT_WITHDRAW: "/payments/withdraw/",
  GET_BALANCE: "/payments/withdraw/check-balance/",
  GET_STRIPE_ACCOUNT_STATUS: "/payments/connect-stripe-account/status/",
  CONNECT_STRIPE: "/payments/connect-stripe-account/",
  CONNECT_STRIPE_API: () => "/payments/connect-stripe-account/",
  GET_BG_WALLPAPERS: "/wheel/get-storage-images/",
  GET_PRIMARY_WHEEL_V2: (id) => `/api/v2/wheel/primary/?user=${id}`,
  // BUG-chat-avatar-default (2026-08-29): `is_primary` is an explicit opt-in
  // most accounts never set (measured live on staging: user 21 has 59 wheels,
  // 0 marked primary), so GET_PRIMARY_WHEEL_V2 almost always resolves empty
  // even for users with real wheels. Same ordering the rest of the app already
  // uses as "the wheel that represents this user" (`-is_primary`, gallery
  // order, `-updated_at` — see WheelViewSet mode=created) — a primary wheel,
  // if set, still sorts first, so this is a fallback source, not a behavior
  // change for users who did set one.
  GET_PRIMARY_OR_TOP_WHEEL_V2: (id) =>
    `/api/v2/wheel/?user_id=${id}&mode=created&page_size=1&add_primary=true`,
  DELETE_WHEEL_V2: (id) => `/api/v2/wheel/${id}/`,
  FAVORITE_WHEEL: (id) => `/api/v2/wheel/${id}/like-unlike/`,
  // --- Wheel Comments (v1, whole-wheel; gated by COMMENTS_ENABLED). See specs/comments/SCOPE-2026-07-21.md §2g ---
  WHEEL_COMMENTS: (wheelId) => `/api/v2/wheel/${wheelId}/comments/`,
  COMMENT_REPLIES: (commentId) => `/api/v2/comments/${commentId}/replies/`,
  DELETE_COMMENT: (commentId) => `/api/v2/comments/${commentId}/`,
  EDIT_COMMENT: (commentId) => `/api/v2/comments/${commentId}/`,
  REPORT_COMMENT: (commentId) => `/api/v2/comments/${commentId}/report/`,
  LIKE_COMMENT: (commentId) => `/api/v2/comments/${commentId}/like/`,
  WHEEL_COMMENTS_SETTINGS: (wheelId) => `/api/v2/wheel/${wheelId}/comments/settings/`,
  CREATE_FOLDER: `/api/v2/folders/`,
  GET_FOLDERS: `/api/v2/folders/`,
  // bug#953: single-folder retrieve (same URL UPDATE_FOLDER/DELETE_FOLDER
  // already use, named for its GET call sites) and the public share-link
  // resolver -- unauthenticated, resolves a share slug directly to its
  // collection.
  GET_FOLDER: (id) => `/api/v2/folders/${id}/`,
  SHARED_FOLDER: (slug) => `/api/v2/folders/shared/${slug}/`,
  // #920 §5 — the global search's Collections tab. The collections endpoint is
  // not a search endpoint: `search` is sent because it costs nothing if the
  // serializer grows support for it, but the name matching that the tab
  // actually relies on happens client-side (FoldersV2/collectionSearch.js), so
  // the tab is correct whether or not BE honours the param. `user` scopes it to
  // the signed-in account — cross-user collection search needs a real BE index.
  SEARCH_COLLECTIONS: ({ user, search, page = 1, page_size = 50 } = {}) =>
    `/api/v2/folders/?user=${encodeURIComponent(
      user ?? ""
    )}&search=${encodeURIComponent(
      search ?? ""
    )}&page=${page}&page_size=${page_size}`,
  REMOVE_WHEEL: (folder_id) => `/api/v2/folders/${folder_id}/remove-wheel/`,
  UPDATE_FOLDER: (id) => `/api/v2/folders/${id}/`,
  DELETE_FOLDER: (id) => `/api/v2/folders/${id}/`,
  MOVE_ITEM: (id) => `/api/v2/folders/${id}/move/`,
  MOVE_FOLDER_TO_ROOT: (id) => `/api/v2/folders/${id}/move-to-root/`,
  // Collections drag-to-reorder persistence (Gordon feature request, 2026-08-27).
  // NOT YET IMPLEMENTED SERVER-SIDE — WheelFolders has no position/order field
  // and this route does not exist on BE today (see useReorderFolders in
  // services/mutations.js). The FE fires it optimistically so persistence
  // starts working the moment BE ships it; until then the request 404s and is
  // swallowed (the existing session-scoped local reorder is unaffected).
  // Proposed contract: PATCH { parent: <folderId|null>, ordered_ids: [id,...] }
  // -> 200, where `parent` scopes ordered_ids to that folder's direct children
  // (null = root level) and ordered_ids is the FULL new sibling order.
  REORDER_FOLDERS: `/api/v2/folders/reorder/`,
  SIGNUP_BETA_V2: () => `/api/v2/signup-beta/`,
  GET_SUGGESTED_COLOR_PALETTE: `/api/v2/wheel/palette-generator/`,
  UNLOCK_WHEEL_V2: (wheelId) => `/wheel/${wheelId}/user-wheel-unlock/`,
  // Payment-gated wheel locking (WL-042 / BE feature #12, PR #1181). Endpoints are
  // inert (return feature_enabled:false / "feature not enabled") unless the backend
  // PAYMENT_LOCKING_ENABLED flag is ON, so these routes never touch the running app.
  WHEEL_PAYWALL: (wheelId) => `/api/v2/wheel/${wheelId}/paywall/`,
  WHEEL_PAYWALL_ACCESS: (wheelId) => `/api/v2/wheel/${wheelId}/access/`,
  WHEEL_PAYWALL_PURCHASE_INTENT: (wheelId) =>
    `/api/v2/wheel/${wheelId}/purchase-intent/`,
  // Owner-scoped creator-earnings roll-up for the Analytics Monetization section
  // (WL-042 / deck locked-wheels-05-management). Same inert-when-off contract as
  // the routes above; the FE renders empty/loading until the BE endpoint lands.
  WHEEL_PAYWALL_EARNINGS: `/api/v2/wheel/paywall/earnings/`,
  // Data-Entry (quiz-as-unlock) lock — Phase 1 MVP. Same inert-when-off contract as
  // the paywall routes: the BE returns "feature not enabled" unless
  // DATA_ENTRY_LOCK_ENABLED is ON. QUIZ handles owner GET/POST/DELETE; SUBMIT is the
  // visitor auto-grade + unlock-grant.
  WHEEL_DATA_ENTRY_QUIZ: (wheelId) => `/api/v2/wheel/${wheelId}/data-entry-quiz/`,
  WHEEL_DATA_ENTRY_SUBMIT: (wheelId) =>
    `/api/v2/wheel/${wheelId}/data-entry-submit/`,
  GET_WHEEL_EMAIL_PERMISSION: (id) => `/api/v2/wheel/${id}/email-permission/`,
  DELETE_WHEEL_EMAIL_PERMISSION: (id) =>
    `/api/v2/wheel/${id}/remove-permission/`,
  TOGGLE_WHEEL_ACTIVE: (wheelId) => `/api/v1/wheel/${wheelId}/toggle-active/`,
  BROADCAST_CHANGES: (wheelId) => `/api/v2/wheel/${wheelId}/broadcast-changes/`,
  VALIDATE_PROMO_CODE: "/payments/change-subscription/validate-promo-code/",
  GET_MEDIA_BY_CATEGORY: (type, pageToken) =>
    `api/media/by-type/?type=${type}&per_page=20&nextToken=${pageToken}`,
  // `status` + `search` are percent-encoded for the same reason as the global
  // search above (a `#`/`&`/`%` typed into the Content-Moderation search box
  // truncated or forged the query). `nextToken` is left as-is on purpose — it is
  // an opaque DRF `next` cursor the BE round-trips, not user input.
  GET_CONTENT_MODERATION_LISTING: (status, search, pageToken) =>
    `api/v2/wheel/moded-content/?per_page=20&nextToken=${pageToken}${
      status ? `&status=${encodeURIComponent(status)}` : ""
    }${search ? `&search=${encodeURIComponent(search)}` : ""}`,
  // MOD-1 staff Moderation Console (flag-gated; BE 404s while OFF). Real BE
  // route is mounted under /wheel/ (yuga_wheel/moderation/urls.py registers
  // "moderation" on the yuga_wheel router, included at the /wheel/ prefix in
  // yuga_wheel/urls.py) — NOT /api/v2/moderation/. The old /api/v2/moderation/
  // prefix 404s unconditionally (no such route exists anywhere in the BE),
  // which is why the console was 100% dead regardless of staff status or the
  // MODERATION_CONSOLE_ENABLED flag.
  MODERATION_QUEUE: ({ status, mediaType, search, limit = 20, offset = 0 } = {}) =>
    `/wheel/moderation/?limit=${limit}&offset=${offset}${
      status ? `&status=${status}` : ""
    }${mediaType ? `&media_type=${mediaType}` : ""}${
      search ? `&search=${encodeURIComponent(search)}` : ""
    }`,
  MODERATION_STATS: () => `/wheel/moderation/stats/`,
  MODERATION_DETAIL: (id) => `/wheel/moderation/${id}/`,
  MODERATION_APPROVE: (id) => `/wheel/moderation/${id}/approve/`,
  MODERATION_REJECT: (id) => `/wheel/moderation/${id}/reject/`,
  MODERATION_REINSTATE: (id) => `/wheel/moderation/${id}/reinstate/`,
  MODERATION_APPEAL_RESOLVE: (id) => `/wheel/moderation/${id}/appeal-resolve/`,
  // OPS-1 staff Ops Console (flag-gated; BE must be staff-permission-gated and
  // 404 while its own flag is OFF / 403 any non-staff caller). Read-only,
  // paginated, scoped-safe users listing — see OPS-CONSOLE-BE-ENDPOINT-SPEC.md.
  GET_OPS_USERS: ({ limit = 20, offset = 0, search, status } = {}) =>
    `api/v2/ops/users/?limit=${limit}&offset=${offset}${
      search ? `&search=${encodeURIComponent(search)}` : ""
    }${status && status !== "all" ? `&status=${status}` : ""}`,
  GET_WHEEL_MEDIA: (wheelId) => `/wheel/wheel-media/${wheelId}`,
  SEND_WHEEL_MEDIA: () => `/wheel/wheel-media/write/`,
  GET_NOTIFICATIONS: (page) => `api/v1/notification/?page=${page}&page_size=10`,
  TAKE_SCREENSHOT_OF_WHEEL: (wheelId) =>
    `/api/v2//wheel/${wheelId}/wheel-preview/`,
  TAKE_WHEEL_SCREENSHOT: (wheelId) =>
    `/api/v2/wheel/${wheelId}/take-screenshot/`,
  GET_PALETTE_LIBRARY: (wheelId, type, search, usageType = 2) =>
    `/api/v2/wheel/palette-library/?wheel_id=${wheelId}&type=${type}&usage_type=${usageType}${
      search ? `&search=${search}` : ""
    }`,
  DELETE_PALETTE: () => `/api/v2/wheel/delete-palette/`,
  GENERATE_SCHEME: () => `/api/v2/wheel/generate-scheme/`,
  SAVE_PALETTE: () => `/api/v2/wheel/save-palette/`,
  GENERATE_COLORS_FROM_IMAGE: () => `/api/v2/wheel/image-palette-generator/`,
  GENERATE_COLORS_FROM_PROMPT: () => `/api/v2/wheel/auto-generate-palette/`,
  MARK_ALL_READ: () => `/api/v1/notification/mark-all-as-read/`,
  MARK_NOTIFICATION_READ: (id) => `/api/v1/notification/${id}/mark-as-read/`,
  /* QA-1014: per-row Delete (FB-style kebab). The notifications API is a DRF
     ModelViewSet, so the router already exposes the default destroy route
     DELETE /api/v1/notification/{id}/ — no BE change needed. The list view
     filters deleted_at__isnull=True, so a deleted row leaves the feed. */
  DELETE_NOTIFICATION: (id) => `/api/v1/notification/${id}/`,
  /* Server-authoritative unread total. The feed endpoint is page-limited
     (page_size=10), so counting unread rows in page 1 caps the badge at 10 —
     MEASURED live on web-stg 2026-07-30: bell read "10 unread" while this
     endpoint returned 26. */
  NOTIFICATION_UNREAD_COUNT: () => `/api/v1/notification/unread-count/`,
  SAVE_RECENT_MEDIA: (wheelId) => `/api/v2/wheel/save-recent-media/`,
  SAVE_EXTERNAL_IMAGE: () => `/api/v2/wheel/save-external-image/`,
  EMBED_URL_REHOST: () => `/api/v2/wheel/embed-url-rehost/`,
  RESOLVE_AUDIO_LINK: () => `/api/v2/media/resolve-audio-link/`,
  SEGMENT_VIDEO_WEB: () => `/api/v2/media/segment-video-web/`,
  DMCA_TAKEDOWN: "/api/v2/copyright-dmca/",
  DMCA_COUNTER: "/api/v2/dmca/",
  CONTENT_REMOVAL_DISPUTE: "/api/v2/crd/",
  // legal-0919: the public /report page's "intimate image" / "other harmful
  // content" categories -- the DMCA-shaped categories above already cover
  // takedown/counter/dispute.
  PUBLIC_CONTENT_REPORT: "/api/v1/public-report/",
  GET_RECENT_MEDIA: (wheelId, type, page = 1) =>
    `/api/v2/wheel/get-recent-media/?type=${type}&page=${page}&per_page=10${
      wheelId ? `&wheel_id=${wheelId}` : ""
    }`,
  GET_TOTAL_STORAGE: () => "api/media/total-storage/",
  // v2 storage usage (backend #1121). Serves zeros until counting/backfill is
  // switched on; the UI handles that pre-backfill state honestly.
  GET_STORAGE_USAGE: () => "/api/v2/storage/usage/",
  GET_TOTAL_MEDIA: () => "api/media/",
  // Media-library "Move to Folder" -- reuses the same WheelFolders folder
  // namespace + viewset as Collections (BE PR#2446/#2459,
  // yuga_wheel/api/v2/viewsets/folder/base.py move_media_to_folder).
  // Addressed by `url` here, matching what the standalone Media Library
  // page's items actually carry (raw S3 objects with no WheelRecentMedia row
  // of their own until filed).
  MOVE_MEDIA_TO_FOLDER: () => "/api/v2/folders/move-media/",
  // Server-side "From your image" swatch extraction for Gallery Theme
  // (FE#6061 / BE#3405) -- our media bucket sends no CORS headers, so the
  // client-side canvas extractor always fails against real uploads.
  GALLERY_THEME_WALLPAPER_PALETTE: () => "/api/v2/gallery-theme/wallpaper-palette/",
  DELETE_MEDIA: () => `api/media/delete/`,
  RENAME_MEDIA: () => `api/media/rename/`,
  // WL-072: which Wheels a media file is attached to (id/name/thumbnail), and
  // detaching it from a caller-selected subset without deleting from the Library.
  GET_MEDIA_WHEELS: () => `api/media/wheels/`,
  REMOVE_MEDIA_FROM_WHEELS: () => `api/media/remove-from-wheels/`,
  DELETE_ALL_MEDIA: () => `api/media/cleanup-storage/`,
  ADD_EMAILS: (wheelId) => `/api/v2/wheel/${wheelId}/add-emails/`,
  GET_COMMISSION_STRUCTURE: `/api/v1/referrals/commission-structure/`,
  GET_COMMISSION_EVALUATION: `/api/v1/referrals/evaluation/`,
  POST_MEDIA_MODERATION: () => `/api/v2/wheel/image-mod/`,
  POST_SCREENSHOT: (wheelId) => `/api/v2/wheel/${wheelId}/save-preview/`,
  DELETE_WHEEL_MEDIA: () => `/wheel/wheel-media/delete/`,
  GET_PROFILE_BY_REFER_CODE: (code) =>
    `api/v1/profile-by-ref/?referral_id=${code}`,
  GET_LATEST_WHEEL_TO_SHOW_IN_REFER_MODAL: (id) =>
    `api/v2/wheel/profile-wheel/?user=${id}`,
  GET_TOKEN_BUNDLES: "/api/v2/wheel/list-token-bundles/",
  PURCHASE_TOKEN_BUNDLE: "/api/v2/wheel/choose-token-bundle/",
  GET_SEGMENT_DETAILS: (segmentId) => `/api/v2/activity/${segmentId}/`,
  CHECK_REFERRAL: () => "api/v1/referrals/check-referral/",
  GET_TERMS_AND_CONDITIONS: "/modules/terms-and-conditions/",
  GET_TERMS_ACCEPTANCE_STATUS: "/modules/terms-acceptance/status/",
  RECORD_TERMS_ACCEPTANCE: "/modules/terms-acceptance/accept/",
  LEAVE_EARNINGS_PROGRAM: "/modules/terms-acceptance/leave-earnings-program/",
  // minors-w2-fe-settings-age-dob-and-referral-gate (mission minors-13plus,
  // plan ~/plans/minors-13plus-compliance-2026-09-14.md, B.13). Backend PR
  // #3170 — 404s while settings.MINORS_POLICY_ENABLED is off.
  UPDATE_DOB: "/api/v2/users/me/dob/",
  RENAME_COLOR_PALETTE: "/api/v2/wheel/rename-palette/",
  GET_THEME_LIBRARY: (type, search) =>
    `/api/v2/wheel/theme-library/?type=${type}${search ? `&search=${search}` : ""}`,
  SAVE_THEME: () => `/api/v2/wheel/save-theme/`,
  RENAME_THEME: "/api/v2/wheel/rename-theme/",
  DELETE_THEME: () => `/api/v2/wheel/delete-theme/`,
  STORE_EMAIL_REFERRAL_CODE: "/api/v1/referrals/email-referral-codes/store/",
  STORE_PENDING_APP_INSTALL: "/api/v1/referrals/pending-app-install/store/",
  GET_WHEEL_COUNT: "/wheel/wheel-count/",
  // Legacy chat GPT helper still referenced by useAIGeneratedText in mutations.js
  // (dev path; sandbox DM rewrite did not replace this mutation).
  GENERATE_AI_TEXT: "/api/v1/chat/room/gpt/",
  GENERATE_AI_COMPLETION: "/api/v2/openai/completion/",
  GENERATE_AI_SUGGESTIONS: "/api/v2/openai/suggestions/",
  GENERATE_AI_TITLES: "/api/v2/openai/titles/",
  HELP_ASSISTANT: "/api/v2/help-assistant/",
  /* Capture / Notepad inbox (backend #1182). Surface mounted at /capture/. */
  CAPTURE_ITEMS: "/capture/items/",
  /* Export ALL (C15.13): the caller's entire inbox as one un-paginated manifest
     (owner-scoped, read-only) for client-side download. */
  EXPORT_CAPTURE_ITEMS: "/capture/items/export/",
  ATTACH_CAPTURE_ITEM: (id) => `/capture/items/${id}/attach/`,
  /* Wheel-scoped detach (ISP-9999 M2M): removes ONE (item, wheel) pair and
     leaves every OTHER wheel the capture is attached to intact. Distinct from
     the legacy "attach with a null wheel" detach, which cleared ALL attachment.
     Body: { wheel_id }. See services/capture.detachCaptureItemFromWheel. */
  DETACH_CAPTURE_ITEM: (id) => `/capture/items/${id}/detach/`,
  /* Several wheels in one request: POST { wheel_ids: [...] }. */
  DETACH_CAPTURE_WHEELS: (id) => `/capture/items/${id}/detach-wheels/`,
  DELETE_CAPTURE_ITEM: (id) => `/capture/items/${id}/`,
  /* Same detail URL as DELETE_CAPTURE_ITEM (REST convention: one resource URL,
     verb picks the action) -- named separately for call-site clarity (CAP-3). */
  UPDATE_CAPTURE_ITEM: (id) => `/capture/items/${id}/`,
  /* Direct messages (DM) — backend #1199, gated behind CHAT_ENABLED (default OFF).
     Distinct from the legacy `/api/v1/chat/room/` rooms above. */
  DM_CONVERSATIONS: "/api/v1/dm/conversations/",
  DM_CONVERSATION: (id) => `/api/v1/dm/conversations/${id}/`,
  DM_MESSAGES: (id) => `/api/v1/dm/conversations/${id}/messages/`,
  DM_MARK_READ: (id) => `/api/v1/dm/conversations/${id}/read/`,
  /* Mute / unmute (C4) and soft-leave (I6) — per-user, participant-scoped.
     404 while CHAT_ENABLED is off, same as the rest of the DM surface. */
  DM_MUTE: (id) => `/api/v1/dm/conversations/${id}/mute/`,
  DM_UNMUTE: (id) => `/api/v1/dm/conversations/${id}/unmute/`,
  DM_LEAVE: (id) => `/api/v1/dm/conversations/${id}/leave/`,
  /* Edit (PATCH) / self-delete (DELETE) own message — 1:1 polish. */
  DM_MESSAGE_DETAIL: (id) => `/api/v1/dm/messages/${id}/`,
  DM_REPORT_MESSAGE: (id) => `/api/v1/dm/messages/${id}/report/`,
  DM_WS_TICKET: "/api/v1/dm/ws-ticket/",
  /* BUG #919 — chat-message reactions (WhatsApp/emoji style). NO BACKEND
     ENDPOINT EXISTS YET for this pair (distinct from the unrelated
     SegmentReactions `/reactions/` surface on wheels/segments) — these paths
     are the FE's EXPECTED contract, so the mutation lights up the instant
     BE adds it. Mirrors DM_MESSAGE_DETAIL's shape: POST to add/replace the
     caller's own reaction, DELETE (by emoji) to remove it. 404s until BE
     ships; see services/chat.js useToggleMessageReaction for the rollback. */
  DM_MESSAGE_REACTIONS: (id) => `/api/v1/dm/messages/${id}/reactions/`,
  DM_MESSAGE_REACTION_DETAIL: (id, emoji) =>
    `/api/v1/dm/messages/${id}/reactions/${encodeURIComponent(emoji)}/`,
  /* ISP-9999 (Gordon #chatmedia-save): copy a media message's attachment into
     the CALLER's own Media Library root. Any active participant (sender or
     receiver) may call this on a qualifying (image/video/gif) attachment. */
  DM_MESSAGE_SAVE_TO_LIBRARY: (id) => `/api/v1/dm/messages/${id}/save-to-library/`,

  // User blocking (#18 Gap #1). These 404 until the backend flag
  // USER_BLOCKING_ENABLED is on -- the FE never calls them while
  // USER_BLOCKING_ENABLED (build flag) is off.
  USER_BLOCK: (id) => `/api/v1/user/${id}/block/`,
  USER_UNBLOCK: (id) => `/api/v1/user/${id}/unblock/`,
  USER_BLOCK_STATUS: (id) => `/api/v1/user/${id}/block-status/`,
  /* minors-13plus wave 2 (ISP-9999, minors-w2-fe-block-report-ui): the NEW
     safety-surface Block/Report-user contract shared with the parallel BE
     unit minors-w2-be-block-user. Distinct from the v1 DM-only USER_BLOCK*
     trio above (messaging.Block, chat-scoped) — these back Block/Report from
     the Gallery profile card kebab, comment kebab, and the Settings > Privacy
     Blocked list. 404 until that BE PR deploys; every caller here treats a
     404 as "capability unavailable" and hides the action instead of
     surfacing an error (no FE flag — see services/userSafety.js). */
  USER_BLOCK_V2: (id) => `/api/v2/users/${id}/block/`,
  USER_BLOCKED_LIST_V2: "/api/v2/users/me/blocked/",
  USER_REPORT_V2: (id) => `/api/v2/users/${id}/report/`,
  /* Notification preferences (DL-053) — GET/PATCH per-category In-app toggles.
     Gated behind the backend NOTIFICATION_PREFERENCES_ENABLED (404s while OFF). */
  NOTIFICATION_PREFERENCES: "/api/v1/notification/preferences/",
};

export const ASSETS = {
  PopupLogo,
  userimg,
  ppt,
  userPlaceholder:
    "https://iyuga-backend.s3.amazonaws.com/uploads/9cb11984-feca-4a49-b448-2b212c73caa3-TEXTS.svg",
  wheelLogoFallback: DefaultIyugaLogo,
  search,
  SearchIcon2,
  SearchIconActive,
  ClearIcon,
  google,
  signup_rightimg,
  signup_logo,
  google_logo,
  wheelPrivate,
  facebook_logo,
  validation_error,
  createwheel,
  wheel_img,
  upload,
  filter_icon,
  info2,
  aiError,
  search_icon,
  Faq,
  share,
  edit,
  messenger,
  twitter,
  defaultGrid,
  masonryGrid,
  EmptyDisplayImage,
  quiltedGrid,
  pinterest,
  email,
  link,
  fb,
  Office,
  google2,
  beta,
  cross,
  website,
  pdf,
  xls,
  doc,
  img,
  sms,
  SMSNew,
  copy,
  refresh,
  SuggestionIcon,
  vertical_dots,
  delete_icon,
  csv,
  Pencil,
  LockOpen,
  GDocs,
  Referrals,
  GDrive,
  GSheets,
  GSlides,
  GForms,
  LockKey,
  Lock,
  Eye_1,
  Eye_2,
  EyeClosed,
  ReplaceAudio,
  image,
  Primary,
  emptyWheel2,
  favourite,
  clock,
  DownArrow,
  arrowArcLeft,
  createWheelLockIcon,
  createWheelEyeIcon,
  createWheelPrimaryIcon,
  EditImage,
  uploadImage,
  peye_off,
  peye,
  timemock_img,
  customock_img,
  AudioRecorder,
  MobileDesc2,
  NonPrimary,
  custom_default,
  document,
  time_default,
  search_Icon,
  instagram,
  profileFacebook,
  profileTwitter,
  StaticTimedWheel,
  referralsIcon,
  unlockIcon,
  revenueIcon,
  Completed,
  Wheely,
  clone_green,
  notification_autodeposit,
  notification_bulb,
  notification_clone,
  notification_collab,
  notification_expiry,
  notification_follow,
  notification_heart,
  notification_live_clone,
  notification_lock,
  notification_message,
  notification_red_storage,
  notification_share,
  notification_tax,
  notification_unlock,
  notification_warning,
  notification_yellow_storage,
  unlock_purple,
  unlock_yellow,
  Clone,
  backroundWheel,
  backgroundWheelProfile,
  settings,
  explore,
  CheckCircle,
  bb_default_profile_image,
  AddSocialMedia,
  bb_upload_adv_img,
  LinkBreak,
  unlink,
  linkpopup,
  Check,
  bb_social_instagram,
  AttachIcon,
  jpeg,
  bb_social_twitter,
  bb_social_tiktok,
  bb_social_linkedin,
  wheelSetting,
  video,
  plus,
  padlock,
  clone,
  tabGallery,
  SegmentPreview,
  tabPrivate,
  tabClone,
  eye,
  tabUnlock,
  expand,
  AIWheelProgress1,
  AIWheelProgress2,
  AIWheelProgress3,
  UserSearchThumb,
  expandWhite,
  attachment,
  LoginPortrait,
  LoginTablet,
  ReferQr,
  ReferInitialBg,
  totalIncome,
  ytdIncome,
  TextLeftAlign,
  TextCenterAlign,
  TextRightAlign,
  download,
  nextMonthsIncome,
  person,
  analyticsBg,
  legendIcon,
  linksIcon,
  authenticator,
  removeIcon,
  ColorPicker,
  viewMediaIcon,
  mediaSidebarIcon,
  mp3Icon,
  pdfIcon,
  apple,
  infoIcon,
  OneDrive,
  crossIcon,
  cloneDark,
  publicDark,
  privateDark,
  unlockDark,
  hotbarIcon,
  BotIcon,
  uploadMediaIcon,
  aiGeneratorIcon,
  canvasIcon,
  gradientBg,
  aiBot,
  videoPlayer,
  pencilEditIcon,
  addLink,
  youtubeIcon,
  addSegmentIcon,
  emptyWheel,
  Pexels,
  Hamburger,
  Bing,
  businessbox,
  noBusinessbox,
  linkError,
  linkSuccess,
  copyIcon,
  youtubeicon,
  messageIcon,
  blueClone,
  blueHeart,
  blueShare,
  whitePencil,
  timeClock,
  bg,
  halloffame,
  discovericon,
  createWheelNav,
  deleteIcon2,
  emoji,
  feedbackIcon,
  feedback2,
  loaderGif,
  customizeIcon,
  leftSbBackIcon,
  resetIcon,
  miniMenu,
  author,
  noPreview,
  UNDER_CONSTRUCTION,
  Content_Full_Preview,
  MobileLogo,
  MobileDesc,
  TooltipFill,
  TooltipOutlilne,
  LinksIconMobile,
  iyugaLogo,
  iyugaBetaLogo,
  MediaBlueIcon,
  EyeDropper,
  MediaWhite,
  gradientBgNew,
  Account,
  Billing,
  Data,
  Feedback,
  Subscription,
  Insurance,
  Security,
  Password,
  Session,
  Notifications,
  PersonalSettings,
  RotateLeft,
  RotateRight,
  Mwheelloader,
  WheelMovbileBox,
  PinnedIcon,
  UnPinnedIcon,
  ReferInvite,
  QrRefer,
  Send,
  ReferCopy,
  Wallet,
  Withdrawal,
  Congratulations,
  Sad,
  WheelPantry,
  pantry,
  linkHorizontalIcon,
  lockIcon,
  usersListIcon,
  shareSegmentIcon,
  segmentEditor: {
    Header,
    Image,
    ImageAbove,
    ImageBelow,
    ImageGrid,
    ImageWithText,
    Masonry,
    SocialLinks,
    Social,
    QuiltedImage,
    Text,
    Video,
    Document,
    Document2,
    WovenImage,
    EmptySegmentContainer,
    ContentWidth,
    Audio,
    FullWidth,
    GraphBlock,
    TypographyIcon,
    DeleteIcon,
    CopyIcon,
    ContainerSetting,
    Divider,
    ContainerWallpaper,
    DummyPattern,
    UploadImage,
    UploadVideo,
    SearchIcon,
    Accordion,
    ImageTitleImage,
    RightAlign,
    LeftAlign,
    Home,
    View,
    Save,
    DummySocial,
    SearchV2,
    QuillPen,
    Setting,
    Copilot,
    Capture,
    Segment,
    SegmentLibrary,
    Pantry,
    Edit,
    ProfileLogo,
    BookIcon,
    LinkWheelIcon,
    ReloadIcon,
    Plus,
    CenterAlignment,
    LeftAlignment,
    RightAlignment,
    ButtonBlock,
    ClockWise,
    AntiClockWise,
    CloneIcon,
    ShareIcon,
    LikeIcon,
    Bookmark,
    Description,
    GridUpload,
    GridIcon,
    TableIcon,
    ReplaceImage,
    EditPencil,
    DeleteOutline,
    ViewV2,
    DefaultWallpaperForViewWheel,
    SegmentSampleIcon,
    SegmentIconV2,
    EditPencilV2,
    Speaker,
    Sample_Business,
    AtTheRate,
    TwitterIcon,
    UkIcon,
    MessengerIcon,
    YoutubeIcon,
    PincentIcon,
    FacebookIcon,
    ShareIconV2,
    PincentIconV2,
    FacebookIconV2,
    TwitterIconV2,
    InstagramIcon,
    LinkIcon,
    MusicNode,
    ListIcon,
    GridV2,
    List,
    GridV3,
    ListV2,
    EmptyWheelListing,
    ListV3,
    GridV4,
    AddWheel,
    NotificationIcon,
    PublicWheel,
    PrivateWheel,
    LockWheel,
    CloneWheel,
    LiveShare,
    LiveShareV2,
    AddWheelV2,
    FilterIcon,
    EmptyFolder,
    PublicVisible,
    PrivateVisible,
    AddFolder,
    PublicFolder,
    PrimaryFolder,
    PrivateFolder,
    comingSoonV2,
    OldWheels,
    Folder,
    Incognito,
    LockWheelEmailListIcon,
    CloneModalIcon,
    EmptyNestedFolder,
    RemoveFromFolder,
    Business,
    Hotbar,
  },
  SegmentSettingsIcon,
  DialogImg,
  TimeoutPopupWheel,
  LableToggleIconMobile,
  LableToggleIconMobileFilled,
  WantIn,
  EnterBeta,
  IyugaWhiteLogo,
  Saving,
  UnsavedChanges,
  OnlySave,
  BroadCastIcon,
  BroadCastUpdateYellowIcon,
  Sync2,
  SyncWarning,
  SyncError,
  CloningDisabled,
  ImagesIcon,
  VideosIcon,
  DocumentsIcon,
  AudiosIcon,
  LinksIcon_hotbar,
  NewAiIcon,
  NewDoc,
  Premium,
  CreatedTabEmptyState,
  ClonedTabEmptyState,
  UnlockedTabEmptyState,
  FavouritedTabEmptyState,
  InviteBtn,
  StorageAudio,
  BlueStorage,
  PrimaryWheelPlaceholder,
  premiumWheel,
  ContentModeration,
  InviteShare,
  JustMessenger,
};

export const TOAST_TYPE = {
  SUCCESS: "success",
  ERROR: "danger",
  WARNING: "warning",
};

export const PATH = {
  DASHBOARD: "/",
  CHART: "/chart",
  USER: "/user",
  MY_PROFILE: "/myprofile",
  PROFILE: "/profile/:userid",
  OTHER_USER_PROFILE: "/otheruserprofile/:userid",
  SUPPORT: "/support",
  HELP: "/help",
  SUGGESTIONS: "/suggestions",
  LOGIN: "/login",
  SIGNUP: "/signup",
  RESET_PASSWORD: "/resetpassword",
  FORGOT_PASSWORD: "/forgot-password",
  // Login L4 -- passwordless email magic-link (flag-gated, see magicLinkFlag.js).
  MAGIC_LINK_REQUEST: "/login/magic-link",
  MAGIC_LINK_LOGIN: "/login/magic-link/:token",
  FAQ: "/faq",
  CREATE_CUSTOM_WHEEL: "/customwheel",
  /** @deprecated Legacy route — redirects to `/wheel/:wheelId` (ViewWheel). */
  VIEW_WHEEL: "/wheel/:wheelId/:color/:tempId",
  EDIT_WHEEL: "/editwheel/:wheelId",
  SUBSCRIPTION: "./subscription",
  SUBSCRIPTION_DETAILS: "/subscriptionDetails/:subscriptionId",
  SETTINGS: "/settings",
  terms: "/t&c",
  privacy: "/privacy-policy",
  // legal-0919: public, logged-out DMCA/report route.
  REPORT: "/report",
  GALLERY: "/gallery",
  USER_GALLERY: "/gallery/:id",
  // BUG-953: a Collection's shareable link only carries the folder id -- this
  // route resolves the owner and redirects into USER_GALLERY's existing
  // `?collection=<id>` deep-link (see CollectionRedirect.jsx).
  COLLECTION: "/collection/:collectionId",
  DISCOVER: "/discover", // QA-116 item 1 / QA-17: the consolidated Discover surface + the default logged-in landing

  GALLERY_THEME: "/gallery/theme", // flag-gated (REACT_APP_GALLERY_THEMING) creator theming studio
  MODERATION_CONSOLE: "/moderation", // flag-gated (REACT_APP_MODERATION_CONSOLE) staff review queue (MOD-1)
  OPS_CONSOLE: "/ops", // flag-gated (REACT_APP_OPS_CONSOLE) staff-only Ops Console (OPS-1)
  // gordon-0923-P1: hidden, DEV-ONLY, staff-only AI Wheel Lab (multimodel
  // generate compare). Flag-gated (REACT_APP_AI_WHEEL_LAB_ENABLED, declared
  // ONLY in DevOps-Dev.yml) — the route itself is unregistered elsewhere, so
  // it 404s rather than merely rendering empty. No nav link anywhere.
  AI_WHEEL_LAB: "/internal/ai-wheel-lab",
  MEDIA_LIBRARY: "/media-library",
  ONBOARDING: "/onboarding",
  ANALYTICS: "/analytics",
  RESPONSES: "/responses", // flag-gated (REACT_APP_RESPONSES_SECTION) owner-only Forms|Polls|Data-entry lock|Paid unlocks tabs
  CAPTURE: "/capture",
  FOLLOWING: "/following", // flag-gated (REACT_APP_FOLLOWER_FEED) Follower Feed of creators you follow
  MESSAGES: "/messages",
  MESSAGES_THREAD: "/messages/:conversationId",
  // AI-03: flag-gated (AI_WHEEL_GENERATOR_ROUTE_ENABLED, default OFF) route that
  // surfaces the already-built AI Wheel Generator. Unregistered while OFF.
  AI_WHEEL_GENERATOR: "/create/ai-wheel",
};

export const QUERY_KEYS = {
  publicApiKeys: "publicApiKeys", // Developer public-API keys portal
  publicApiKeyUsage: "publicApiKeyUsage", // per-key usage/quota query
  passkeys: "passkeys", // FEAT-L9 Settings > Security passkeys list
  useWheelVersions: "useWheelVersions", // WL-043 wheel version history
  getWheelHomeView: "getWheelHomeView",
  useUserWheelStats: "useUserWheelStats",
  useUserWheelAnalytics: "useUserWheelAnalytics",
  useUserWheelHallOfFame: "useUserWheelHallOfFame",
  useAnalyticsTimeseries: "useAnalyticsTimeseries", // ADDENDUM 2 timeseries chart
  useTotalStorage: "useTotalStorage", // U12a Settings storage meter

  getAllCategories: "getAllCategories",
  getLatestWheel: "getLatestWheel",
  useGetAllTags: "useGetAllTags",
  useSearchWheel: "useSearchWheel",
  useGetWheelSection: "useGetWheelSection",
  useGetUserWheelsById: "useGetUserWheelsById",
  useGetMediaBrowser: "useGetMediaBrowser",
  useGetReferralsChart: "useGetReferralsChart",
  useGetUserPrivateWheelsById: "useGetUserPrivateWheelsById",
  useGetUserUnlockedWheelsById: "useGetUserUnlockedWheelsById",
  useGetUserClonedWheelsById: "useGetUserClonedWheelsById",
  useGetUserClonedSegmentssById: "useGetUserClonedSegmentssById",
  useGetUserProfileById: "useGetUserProfileById",
  useGetAllSubcriptions: "useGetAllSubcriptions",
  useGetSubscriptionDetails: "useGetSubscriptionDetails",
  useGetAllWallpapers: "useGetAllWallpapers",
  useGetPrimaryBusinessBox: "useGetPrimaryBusinessBox",
  useGetWheelAuthors: "useGetWheelAuthors",
  useCreateSetupIntent: "useCreateSetupIntent",
  useGetWheelDetails: "useGetWheelDetails",
  useGetPrimaryWheel: "useGetPrimaryWheel",
  useGetUserFolders: "useGetUserFolders",
  listAllCards: "listAllCards",
  getRefundAmount: "getRefundAmount",
  upcomingSubscriptionChanges: "upcomingSubscriptionChanges",
  activeSubscription: "activeSubscription",
  termsAndConditions: "termsAndConditions",
  termsAcceptanceStatus: "termsAcceptanceStatus",
  useStorageUsage: "useStorageUsage",
  useGetFAQ: "useGetFAQ",
  captureItems: "captureItems",
  dmConversations: "dmConversations",
  dmMessages: "dmMessages",
  // BUG-usman-chat-U6/U7: the conversation payload's `is_blocked` is symmetric,
  // so it cannot tell the blocker from the blocked. Direction lives on
  // GET /api/v1/user/{id}/block-status/ and is cached under this key.
  dmBlockStatus: "dmBlockStatus",
  notificationPreferences: "notificationPreferences", // DL-053 Settings notif prefs
  useWheelComments: "wheel-comments",
  useCommentReplies: "comment-replies",
  // minors-w2-fe-block-report-ui: v2 Blocked-users list (Settings > Privacy +
  // the capability probe every Block/Report-user action shares).
  userBlockedListV2: "userBlockedListV2",
};

export const ERROR_MESSAGE = {
  REQUIRED_FIELD: "Required field",
};

// ISP-9999 (2026-08-30, trailing-slash fix 2026-09-21 auth-0921-P0): APPLE_ID /
// APPLE_REDIRECT_URI were hardcoded to a stale legacy Botics staging host
// (yuga-36787-staging.botics.co) — PR #4751 wired that literal into
// LoginSocialApple on /login + /signup (src/pages/Auth/Login, src/pages/Auth/Signup), so
// tapping "Continue with Apple" sent the user's Apple popup to a dead host. Made env-driven:
// REACT_APP_APPLE_CLIENT_ID / REACT_APP_APPLE_REDIRECT_URI when set, else the app's own
// CURRENT origin + "/" for the redirect (never a foreign host) and the existing literal
// client id as the id fallback. The trailing slash matches how the owner's NEW Apple
// Services ID Return URLs are registered (e.g. https://web.iyuga.net/, not bare
// https://web.iyuga.net) — an exact-match requirement on Apple's side. Guarded for
// non-browser/SSR/module-load contexts where `window` is undefined (never crashes;
// falls back to undefined, same as before this fix existed).
// NOTE: the Apple Services ID's registered "Return URL" in the Apple Developer console must
// include this app's real origin (e.g. https://web-stg.iyuga.net/) for the popup to complete —
// that is a console action for Gordon/Terry, not code (see the PR body).
const _appleRedirectOrigin =
  typeof window !== "undefined" && window.location && window.location.origin
    ? `${window.location.origin}/`
    : undefined;

// ISP-9999 (2026-09-19, Gordon picked "Google A"): GOOGLE_ID was hardcoded to a client
// registered in a Google Cloud project nobody on the team can open. Made env-driven the
// same way APPLE_ID already is: REACT_APP_GOOGLE_CLIENT_ID when set, else the existing
// literal client id as the fallback (zero behaviour change until the env var is set).
// FACEBOOK_ID made env-driven for consistency (currently unconsumed by any component).
// ISP-9999 (origdev-0921-fe-google-clientid-source-literal-refresh, 2026-09-25): fallback
// literal refreshed to Gordon's new client (keen-metric-393218) so a build path that never
// sets REACT_APP_GOOGLE_CLIENT_ID (local/manual build) no longer regresses to the orphaned
// original-dev client nobody on the team can open.
export const Client_App_ID = {
  GOOGLE_ID:
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    "590740184591-1mkbgec0fck1t6gm8tgatnibjhr8tv4g.apps.googleusercontent.com",
  FACEBOOK_ID: process.env.REACT_APP_FACEBOOK_APP_ID || "848410477295893",
  APPLE_ID: process.env.REACT_APP_APPLE_CLIENT_ID || "com.yugaapp.web",
  APPLE_REDIRECT_URI:
    process.env.REACT_APP_APPLE_REDIRECT_URI || _appleRedirectOrigin,
};

console.log(process.env.REACT_APP_BASE_URL, "process.env.BASE_URL");
